module.exports = __webpack_public_path__ + "fonts/CeraPro-Black.afbc5d0.woff2";